import React, { useEffect, useState, useRef } from "react"
import Slider from "react-slick"
import PropTypes from "prop-types"
import Typography from "../UI/Typography/Typography"
import * as style from "./StockSlider-tw-styles"
import { getStockDetails } from "../../service/StockService"
import { Asof, EDT } from "../../constants/label.constants"
import Image from "../UI/Image/Image"
import { imageConstants } from "../../constants/image.constants"

const CustomButton = props => {
  const { className, style, onClick, eventLabel } = props

  return (
    <button
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
      role="button"
      aria-label={eventLabel}
    />
  )
}
CustomButton.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  eventLabel: PropTypes.string,
  onClick: PropTypes.func,
}

const StockSlider = props => {
  const [title, setTitle] = useState("")
  const [symbol, setSymbol] = useState("")
  const [description, setDescription] = useState("")
  const [slides, setSlides] = useState([])
  const [isStockHigh, setStockHigh] = useState(false)
  const [currentSlide, setCurrentSlide] = useState(0)
  let sliderRef = useRef(null);

  useEffect(() => {
    addStockDetails()
  }, [])

  const addStockDetails = async () => {
    
    // API Call
    const stockApiData = await getStockDetails().catch((e) => console.log(e))
    if(stockApiData !== undefined && stockApiData.length > 0) {
      let {
        symbol,
        lastTrade,
        exchange,
        date,
        changePercent,
        changeNumber,
        volume,
        dayHigh,
        dayLow,
        open,
        previousClose,
      } = stockApiData[0]
    if (changeNumber < 0) setStockHigh(false)
    else setStockHigh(true)
      
    let weekHigh = stockApiData[0]["52WeekHigh"]
    let weekLow = stockApiData[0]["52WeekLow"]
    
    setTitle(exchange)
    setSymbol(symbol)
    let conDate = new Date(date)
    setDescription(
      conDate
        .toLocaleString([], {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
        .replace(",", "")
    )
    let slidesCollection = [
      {
        title: "Current share Price",
        description: "$" + lastTrade.toString(),
        img: imageConstants?.greenArrow,
      },
      {
        title: "Change",
        description: changePercent.toString() + "%",
      },
      {
        title: "Volume",
        description: volume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
      },
      {
        title: "Open",
        description: "$" + open.toString(),
      },
      {
        title: "Previous Close",
        description: "$" + previousClose.toString(),
      },
      {
        title: "Day High",
        description: "$" + dayHigh.toString(),
      },
      {
        title: "Day Low",
        description: "$" + dayLow.toString(),
      },
      {
        title: "52-Week High",
        description: "$" + weekHigh.toString(),
      },
      {
        title: "52-Week low",
        description: "$" + weekLow.toString(),
      },
    ]
    setSlides(slidesCollection)
  }
  }

  const settings = {
    dots: true,
    arrows: true,
    swipe: true,
    draggable: true,
    variableWidth: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    accessibility: true,
    nextArrow: <CustomButton eventLabel="Next Slide" aria-label="Next Slide" className={style?.prevArrow} />,
    prevArrow: <CustomButton eventLabel="Previous Slide" aria-label="Previous Slide" className={style?.nextArrow} />,
    afterChange:(index)=>setCurrentSlide(index),
    appendDots: dots => <ul>{dots.map((ele,i)=>{
     return <li key={i} aria-label={`Slide ${i+1} of ${dots.length}`} aria-current={currentSlide==i?"true":"false"}>   
      {ele}
     </li>
    })}</ul>,
    customPaging: i => (
      <button
        aria-label={`Go to slide ${i+1}`}
      />
    ),
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          dots: false,
        },
      },
    ],
  }

   

  const buildSlides = () => {
    return (
      slides?.length > 0 &&
      slides?.map((item, idx) => {
        return (
          <div key={item?.title} className={styles?.blockSlideWrpr}>
            <div className={styles?.blockSlide}>
              {item?.title && (
                <Typography
                  className={styles?.subHeading}
                  content={item?.title}
                />
              )}

              {item?.description && (
                <div className={styles?.descriptionWrapper}>
                  <Typography
                    className={styles?.description}
                    content={item?.description}
                    component="span"
                  />
                  <span
                    className={
                      isStockHigh ? styles?.shareUp : styles?.shareDown
                    }
                  >
                    {item?.img && (
                      <Image contentfulImage={imageConstants?.greenArrow} />
                    )}
                  </span>
                </div>
              )}
            </div>
          </div>
        )
      })
    )
  }

  useEffect(() => {
    const children = document.querySelectorAll(".slick-dots button")
    if (children?.length > 0) {
      ;[...children].forEach((e) => {
        e?.setAttribute("class", "event_slider")
        e?.setAttribute("data-action-detail", "Dots click")
      })
    }
  },[])

  const styles = style?.StockSliderStyles
  return (
    <div className={styles.sliderContainer}>
      <div className={styles.sliderLeftContainer}>
        {symbol && <h1 className={styles.symbol}>{symbol}</h1>}
        <div className={styles.title}>
          {title && <h2>{title}</h2>}
          {Asof}
          {description && <Typography content={description} />}
          {EDT}
        </div>
      </div>

      <div className={styles?.blockSliderWrapper}>
        <Slider ref={sliderRef} {...settings}>{buildSlides()}</Slider>
      </div>
    </div>
  )
}

StockSlider.propTypes = {
  variant: PropTypes.string,
}

export default StockSlider